import { c as _c } from "react/compiler-runtime";
import { Switch } from "@flat-ui";
/**
 * @returns A switch of the DevFeatures table that allows to modify the feature state
 */
export function DevFeatureToggleControl(t0) {
  const $ = _c(6);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = () => item.onToggle(!item.isEnabled);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifySelf: "end",
      overflow: "hidden"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.isEnabled || $[4] !== t1) {
    t3 = <Switch checked={item.isEnabled} onToggle={t1} label="" sx={t2} />;
    $[3] = item.isEnabled;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}